import About from './section/About';
import Clients from './section/Clients';
import Cta from './section/Cta';
import Footer from './section/Footer';
import Header from './section/Header';
import Hero from './section/Hero';
import Offer from './section/Offer';
import Protifilio from './section/Protifilio';
import Reviews from './section/Reviews';
import WhatsAppButton from './section/WhatsAppButton';


export default function App() {
  
  return (
  <>
    <Header/>
    <Hero/>
    <About/>
    <Clients/>
    <Offer/>
    <Protifilio/>
    <div className='overflow-y-hidden'>
    <Reviews/> 
    </div>
    <div className='overflow-y-hidden'>
    <Cta/>
    </div>
    <Footer/>
  <WhatsAppButton/>
  </>
  )
}